var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "main" },
    [
      _c("v-page-header", { attrs: { title: _vm.$t("nav.notifications") } }),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "grid-x align-center" }, [
          _c("div", { staticClass: "cell medium-10 large-12" }, [
            _c(
              "div",
              { staticClass: "box" },
              [
                _c("v-table", {
                  attrs: {
                    isLoading: _vm.notificationsTableLoading,
                    columns: _vm.notificationsTableColumns,
                    items: _vm.notificationsTableItems,
                    showShowAll: false,
                  },
                  on: { rowClicked: _vm.onClickNotification },
                  scopedSlots: _vm._u([
                    {
                      key: "date",
                      fn: function ({ row }) {
                        return [
                          _c("span", { staticClass: "table-date" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm._f("moment")(row.createdon.date, "DD")
                                )
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(row.createdon.date, "MMM")
                                )
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "title",
                      fn: function ({ row }) {
                        return [
                          _c("span", { staticClass: "table-label" }, [
                            _vm._v(_vm._s(row.title)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "table-description" }, [
                            _vm._v(_vm._s(row.description)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("v-pagination", {
                  attrs: {
                    currentPage: _vm.notificationsCurrentPage,
                    itemsPerPage: _vm.notificationsItemsPerPage,
                    items: _vm.notificationsTableItemsCount,
                  },
                  on: { pageClicked: _vm.onChangeNotificationsTablePage },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }